import styled from 'styled-components';
import { StyledPopupWidgetCon, StyledProductItemCon } from '../../../../skins';

export const StyledSlideoutFullpagePopupWidgetCon = styled(
  StyledPopupWidgetCon,
)`
  // & .mr-popup-widget__bottom-bar-con {
  //   position: absolute;
  //   width: 100%;
  //   top: calc(100% - 30px);
  //   left: 0px;
  // }
`;

export const StyledSlideoutFullpageProductItemCon = styled(
  StyledProductItemCon,
)`
  flex-direction: column;

  & .mr-product-item__body-wrapper {
    flex-direction: column;
    align-items: center;
  }

  & .mr-product-item__body {
    justify-content: start;
    width: 100%;
  }

  & .mr-product-body__details {
    flex-grow: 1;
  }
`;
